import { Logger } from "aws-amplify";
import axios from "axios";
import {
  AtticusLogger,
  Network,
} from "@theatticusapp/atticus-shared-components";
import {
  LARAVEL_APP_API,
  LARAVEL_APP_HOST,
  LARAVEL_APP_VERSION,
  LOGGER_NAME,
  SCREEN_PATHS,
} from "../constants";
import { CognitoAuth } from "./CognitoAuth";
import { Invites } from "./Invites";
import { LogProxy } from "./LogProxy";
import { AtticusEstate } from "./AtticusEstate";
import { FinancialConvoAPI } from "./FinancialConvoAPI";
import { ProbateAPI } from "./ProbateAPI";
import { FormsAPI } from "./FormsAPI";
import { EstateFormsAPI } from "./EstateFormsAPI";
import { Geographies } from "./Geographies";

export const laravelApiV1 = LARAVEL_APP_HOST + LARAVEL_APP_API + "/v1";
export const laravelApiV2 =
  LARAVEL_APP_HOST + LARAVEL_APP_API + LARAVEL_APP_VERSION;

// API singletons
export const axiosInstance = axios.create({
  baseURL: laravelApiV2,
});
export const CancelToken = axios.CancelToken;
export const log2Console = process.env.NODE_ENV === "development";

export const authApi = new CognitoAuth(axiosInstance);
export const logger = new AtticusLogger(new Logger(LOGGER_NAME), LogProxy.log);
export const network = new Network(
  axiosInstance,
  logger,
  SCREEN_PATHS.signOut,
  SCREEN_PATHS.maintenance
);
export const estateApi = new AtticusEstate();
export const financialConvoApi = new FinancialConvoAPI();
export const probateApi = new ProbateAPI();
export const formsApi = new FormsAPI();
export const estateFormsApi = new EstateFormsAPI();
export const inviteApi = new Invites();
export const geographiesApi = new Geographies();
